import { StatusObject } from '@yes.technology/react-toolkit'
import apiAsync from 'infrastructure/shared/api/api-async'

export default async function fetchStatuses(
  objectclassUuid: unknown,
  showLoading: boolean
): Promise<StatusObject[] | null> {
  const response = await apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'objects/_filter',
    method: 'POST',
    obj: {
      query: {
        'situation.des': {
          $gte: window.activeSituationCode
        },
        'objectclass.uuid': {
          $in: [objectclassUuid]
        }
      },
      objectclass: 'UUID_OBJECTCLASS_STATUS',
      orderby: [],
      pagination: {
        offset: 0,
        limit: 100
      }
    },
    showLoading
  })

  return response.data.objects as StatusObject[] | null
}
